module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-12-c2836487edf689003b676cd8f3eecc01.jpg";